// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles-module--loading--Apmtu","fadeIn":"styles-module--fadeIn--2j8Yx","pulse":"styles-module--pulse--2npko","slideInDown":"styles-module--slideInDown--2WIPI"};